import React, { useEffect } from 'react'
import { Logger } from 'typescript-log'
import { BaseClientConfig } from '@news-mono/web-common'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router'
import { UserAuthEvents } from '@news-mono/web-common'
import {
    BeginLoadingEvent,
    EndLoadingEvent,
} from 'react-ssr-data-loader/dist/cjs/events'
import { authCheckAccessToken } from '@news-mono/web-common'

interface AuthenticationHandlerProps {
    logger: Logger
    config: BaseClientConfig
    onEvent: (
        authEvent: UserAuthEvents | BeginLoadingEvent | EndLoadingEvent,
    ) => void
}

export const AuthenticationHandler: React.FC<AuthenticationHandlerProps> = ({
    logger,
    onEvent,
}) => {
    const dispatch = useDispatch()
    const location = useLocation()

    useEffect(() => {
        dispatch(authCheckAccessToken({ onEvent, logger, invokation: 'auto' }))
    }, [location.pathname, onEvent, logger, dispatch])

    return null
}
